import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UserNotificationResponse, UserNotificationType } from '../../../../models/users.model';
import * as moment from 'moment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-notification',
  templateUrl: './user-notification.component.html',
  styleUrls: ['./user-notification.component.less']
})
export class UserNotificationComponent implements OnInit, OnChanges {
  @Input() notification: UserNotificationResponse;
  userNotificationType = UserNotificationType;
  @Output() remove: EventEmitter<number> = new EventEmitter();
  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges) {
    const { notification } = changes;
    if (notification && notification.currentValue) {
      this.notification = {
        ...this.notification,
        createDate: moment.parseZone(this.notification.createDate).format('YYYY-MM-DDTHH:mm:ss')
      }
    }
  }
  navigateToUnfulfilledRequest(notification: UserNotificationResponse) {
    this.router.navigate([`/meetings/unfulfilledRequests`], { state: { teamName: notification.data.teamName } })
  }
}
